import React, { useState } from 'react';
import axios from './api/axiosConfig';
import CryptoJS from 'crypto-js';
import './styles/common.css';
import './App.css';

import { AUTH_API_URL, BASE_URL } from './api/config';
const API_URL = AUTH_API_URL;

// SVG 图标组件
const Icons = {
  User: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Lock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
  ),
  Mail: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Phone: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  Eye: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  EyeOff: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  ),
  Home: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
};

// SHA1 哈希函数（使用 crypto-js，不依赖 crypto.subtle）
const sha1 = (message) => {
  return CryptoJS.SHA1(message).toString(CryptoJS.enc.Hex);
};

function LoginPage({ onLoginSuccess, onNavigateToRegister }) {
  const [formData, setFormData] = useState({
    account: '',
    password: ''
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.account.trim()) {
      newErrors.account = '请输入昵称/手机号/邮箱';
    }

    if (!formData.password) {
      newErrors.password = '请输入密码';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoggingIn(true);

    try {
      // 前端计算密码的 SHA1 哈希
      const passwordHash = sha1(formData.password);

      // 发送登录请求
      const response = await axios.post(`${API_URL}/login`, {
        account: formData.account,
        password_hash: passwordHash
      });

      if (response.data.success) {
        // 保存用户信息
        const userInfo = response.data.user_info;
        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        // 保存认证 token（用于跨域请求认证）
        if (response.data.auth_token) {
          localStorage.setItem('authToken', response.data.auth_token);
        }

        // 登录成功后直接刷新主页
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Login error:', error);
      const errorMsg = error.response?.data?.detail || error.message || '登录失败，请检查账号和密码';
      alert(errorMsg);
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-icon">
            <Icons.User />
          </div>
          <h1 className="auth-title">用户登录</h1>
          <p className="auth-subtitle">欢迎回来</p>
        </div>

        <div className="auth-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label required">
                <Icons.User /> 账号
              </label>
              <input
                type="text"
                name="account"
                value={formData.account}
                onChange={handleChange}
                className={`form-input ${errors.account ? 'input-error' : ''}`}
                placeholder="请输入昵称/手机号/邮箱"
              />
              {errors.account && <span className="error-text">{errors.account}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">
                <Icons.Lock /> 密码
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`form-input ${errors.password ? 'input-error' : ''}`}
                  placeholder="请输入密码"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Icons.EyeOff /> : <Icons.Eye />}
                </button>
              </div>
              {errors.password && <span className="error-text">{errors.password}</span>}
            </div>

            <button
              type="submit"
              className="btn-primary auth-btn"
              disabled={loggingIn}
            >
              {loggingIn ? '登录中...' : '立即登录'}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <span>还没有账户？</span>
          <button className="auth-link" onClick={onNavigateToRegister}>
            立即注册
          </button>
          <button className="auth-link back-home" onClick={() => window.location.href = '/'}>
            <Icons.Home /> 返回首页
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
